export default {}

export const pageTitle = 'Unizportal Payment'
// export const apiUrl = `http://localhost:8040`
export const apiUrl = `https://dataapi.unizportal.com`

